

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
      align:'center'
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '博物馆名称',
      align:'center'
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
      align:'center'
    },
    {
      key: 'jointype',
      dataIndex: 'jointype',
      title: '参评方式',
      align:'center'
    },
    {
      key: 'micontact',
      dataIndex: 'micontact',
      title: '联系人',
      align:'center'
    },
    {
      key: 'miphone',
      dataIndex: 'miphone',
      title: '联系电话',
      align:'center'
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '编辑',
      width: 100,
      slot: 'operate',
      fixed: 'right',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
